import React, { useState, useEffect, Fragment } from 'react';
import { Form } from 'react-bootstrap';
import { formatoMonto } from '../../../../common/Formatos';

const CALCULO_MANUAL = 219002;

const CAMPOS_REQUERIDOS = [
    { key: 'recobroCuotas',    label: 'Recobro Cuotas'    },
    { key: 'cantidadDeCuotas', label: 'Cantidad de Cuotas' },
    { key: 'fechaPrimerPago',  label: 'Fecha Primer Pago'  },
    { key: 'diaPago',          label: 'Día Pago'           },
];

const CalendarioDeCuotas = ({
    recobroCuotas,
    cantidadDeCuotas,
    fechaPrimerPago,
    diaPago,
    calcMode,
    setCalcMode,
    calculoMontoCuotaOptions,
    labelCalculo,
    setCuotasCalculadas,
    onCalendarGenerated,
    setCalendarDirty,
    calendarDirty,
    calendarGeneradoRef,
    setCamposFaltantes
}) => {
    const [cuotas, setCuotas] = useState([]);
    const [mostrarGrilla, setMostrarGrilla] = useState(false);
    const [focusedIndex, setFocusedIndex] = useState(null);

    const validarCampos = () => {
        const valores = { recobroCuotas, cantidadDeCuotas, fechaPrimerPago, diaPago };
        return CAMPOS_REQUERIDOS
            .filter(({ key }) => !valores[key] || valores[key] <= 0 || valores[key] === '');
    };

    const calcularCuotasData = (mode) => {
        const fechaInicial = new Date(fechaPrimerPago + 'T00:00:00');
        const nuevasCuotas = [];

        if (parseInt(mode) === CALCULO_MANUAL) {
            for (let i = 0; i < cantidadDeCuotas; i++) {
                let fechaCuota = new Date(fechaInicial);
                fechaCuota.setMonth(fechaInicial.getMonth() + i);
                const isLast = i === parseInt(cantidadDeCuotas) - 1;
                nuevasCuotas.push({
                    nroCuota: i + 1,
                    fechaCuota: fechaCuota.toLocaleDateString('es-ES'),
                    montoCuota: isLast ? parseInt(recobroCuotas || 0) : 0,
                    estado: 'Declarada',
                    codEstado: 293001,
                    montoPagado: 0,
                    fechaDelPago: ''
                });
            }
        } else {
            let montoCuotaBase = Math.trunc(recobroCuotas / cantidadDeCuotas);
            let totalAcumulado = 0;
            for (let i = 0; i < cantidadDeCuotas; i++) {
                let cuotaMonto = (i === parseInt(cantidadDeCuotas) - 1)
                    ? recobroCuotas - totalAcumulado
                    : montoCuotaBase;
                if (i < parseInt(cantidadDeCuotas) - 1) totalAcumulado += cuotaMonto;

                let fechaCuota = new Date(fechaInicial);
                fechaCuota.setMonth(fechaInicial.getMonth() + i);
                nuevasCuotas.push({
                    nroCuota: i + 1,
                    fechaCuota: fechaCuota.toLocaleDateString('es-ES'),
                    montoCuota: cuotaMonto,
                    estado: 'Declarada',
                    codEstado: 293001,
                    montoPagado: 0,
                    fechaDelPago: ''
                });
            }
        }
        return nuevasCuotas;
    };

    const generarCalendario = (mode, esRefresh = false) => {
        const errores = validarCampos();
        if (setCamposFaltantes) setCamposFaltantes(errores.map(e => e.key));
        if (errores.length > 0) {
            setMostrarGrilla(false);
            setCuotas([]);
            setCuotasCalculadas([]);
            return;
        }
        const nuevasCuotas = calcularCuotasData(mode);
        setCuotas(nuevasCuotas);
        setCuotasCalculadas(nuevasCuotas);
        setMostrarGrilla(true);
        if (calendarGeneradoRef) calendarGeneradoRef.current = true;
        if (onCalendarGenerated) onCalendarGenerated(esRefresh);
    };

    useEffect(() => {
        if (!calcMode) return;
        const todosPresentes = recobroCuotas > 0 && cantidadDeCuotas > 0 && fechaPrimerPago && diaPago;
        if (!todosPresentes) return;
        generarCalendario(calcMode, true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [calcMode, cantidadDeCuotas, fechaPrimerPago, recobroCuotas]);

    const handleRadioChange = (value) => {
        setCalcMode(value);
        // Cambiar el radio siempre genera (o intenta generar) el calendario
        generarCalendario(value, false);
    };

const handleMontoCuotaChange = (index, valor) => {
        const nuevoMonto = valor === '' ? 0 : parseInt(valor, 10) || 0;
        const lastIdx = cuotas.length - 1;
        const updated = cuotas.map((c, i) =>
            i === index ? { ...c, montoCuota: nuevoMonto } : c
        );
        const sumOthers = updated.slice(0, lastIdx).reduce((acc, c) => acc + parseInt(c.montoCuota || 0), 0);
        updated[lastIdx] = { ...updated[lastIdx], montoCuota: parseInt(recobroCuotas || 0) - sumOthers };
        setCuotas(updated);
        setCuotasCalculadas(updated);
    };

    const esModoManual   = parseInt(calcMode) === CALCULO_MANUAL;
    const totalCuotas    = cuotas.reduce((acc, c) => acc + parseInt(c.montoCuota || 0), 0);
    const totalPagoCuotas = cuotas.reduce((acc, c) => acc + parseInt(c.montoPagado || 0), 0);
    const saldoAPagar    = totalCuotas - totalPagoCuotas;
    const ultimaMontoCuota = esModoManual && cuotas.length > 0 ? cuotas[cuotas.length - 1].montoCuota : 0;
    const sumaDistinta   = esModoManual && mostrarGrilla && ultimaMontoCuota < 0;

    return (
        <Fragment>
            <style type='text/css'>{`
                .calendario-cuotas { width: 100%; border-collapse: collapse; margin: 0; }
                .calendario-cuotas th,
                .calendario-cuotas td { border: 1px solid #ddd; padding: 7px 10px; text-align: center; }
                .calendario-cuotas th { background-color: #e9ecef; color: #212529; }
                .calendario-cuotas tr:nth-child(even) { background-color: #f9f9f9; }
                .calendario-cuotas tr:hover { background-color: #eee; }
                .cal-header {
                    padding: 8px 16px;
                    background-color: #716e9e;
                    border-top-left-radius: 5px;
                    border-top-right-radius: 5px;
                    color: white;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 12px;
                }
                .cal-header-title { font-weight: bold; white-space: nowrap; }
                .cal-radios-group {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 12px;
                    flex: 1;
                }
                .cal-radios-label { font-weight: bold; font-size: 13px; white-space: nowrap; margin: 0; }
                .cal-radios { display: flex; align-items: center; gap: 14px; }
                .cal-radio-label {
                    display: flex; align-items: center; gap: 5px;
                    cursor: pointer; font-size: 14px; margin: 0;
                }
                .cal-radio-label input { cursor: pointer; }
.cal-alerta-suma { color: #c0392b; font-size: 12px; padding: 3px 16px; }
                .cal-alerta-dirty {
                    color: #664d03; background-color: #fff3cd; border: 1px solid #ffc107;
                    font-size: 12px; padding: 6px 16px; display: flex; align-items: center; gap: 6px;
                }
                .input-monto-cuota { text-align: right; }
                .cal-pie { background-color: #dee2e6; }
            `}</style>

            {/* ── Header: título | label + radios IND 219 centrados | botón refrescar ── */}
            <div className="cal-header">
                <span className="cal-header-title">Calendario de Cuotas</span>
                <div className="cal-radios-group">
                    {labelCalculo && (
                        <span className="cal-radios-label">{labelCalculo} *</span>
                    )}
                    <div className="cal-radios">
                        {calculoMontoCuotaOptions?.map((op) => (
                            <label key={op.id} className="cal-radio-label">
                                <input
                                    type="radio"
                                    name="calcModeCuota"
                                    value={op.id}
                                    checked={parseInt(calcMode) === parseInt(op.id)}
                                    onChange={() => handleRadioChange(String(op.id))}
                                />
                                {op.nombre}
                            </label>
                        ))}
                    </div>
                </div>
            </div>

            {/* ── Alerta dirty: parámetros modificados post-generación ── */}
            {calendarDirty && (
                <div className="cal-alerta-dirty">
                    ⚠ Se han modificado parámetros del calendario. Debe <strong>&nbsp;Refrescar&nbsp;</strong> antes de aplicar el cierre.
                </div>
            )}

            {/* ── Alerta suma manual ── */}
            {sumaDistinta && (
                <div className="cal-alerta-suma">
                    La suma de las cuotas ingresadas supera el Recobro Cuotas ({formatoMonto(recobroCuotas)}). Ajuste los montos.
                </div>
            )}

            {/* ── Grilla ── */}
            {mostrarGrilla && (
                <table className="calendario-cuotas">
                    <thead>
                        <tr>
                            <th>Nro.Cuota</th>
                            <th>Fecha Cuota</th>
                            <th>Monto Cuota</th>
                            <th>Estado</th>
                            <th>Monto Pagado</th>
                            <th>Fecha del Pago</th>
                        </tr>
                    </thead>
                    <tbody>
                        {cuotas.map((cuota, index) => (
                            <tr key={cuota.nroCuota}>
                                <td><strong>{cuota.nroCuota}</strong></td>
                                <td>{cuota.fechaCuota}</td>
                                <td>
                                    {esModoManual ? (
                                        index === cuotas.length - 1 ? (
                                            <Form.Control
                                                type="text"
                                                className="input-monto-cuota"
                                                value={cuota.montoCuota === 0 ? '0' : formatoMonto(cuota.montoCuota)}
                                                disabled
                                                style={{ color: cuota.montoCuota < 0 ? '#c0392b' : 'inherit', fontWeight: 'bold' }}
                                            />
                                        ) : (
                                            <Form.Control
                                                type={focusedIndex === index ? 'number' : 'text'}
                                                className="input-monto-cuota"
                                                value={focusedIndex === index
                                                    ? (cuota.montoCuota === 0 ? '' : cuota.montoCuota)
                                                    : (cuota.montoCuota === 0 ? '' : formatoMonto(cuota.montoCuota))
                                                }
                                                min={0}
                                                placeholder="0"
                                                onFocus={() => setFocusedIndex(index)}
                                                onBlur={() => setFocusedIndex(null)}
                                                onChange={(e) => handleMontoCuotaChange(index, e.target.value)}
                                            />
                                        )
                                    ) : (
                                        formatoMonto(cuota.montoCuota)
                                    )}
                                </td>
                                <td>{cuota.estado}</td>
                                <td>{cuota.montoPagado > 0 ? formatoMonto(cuota.montoPagado) : ''}</td>
                                <td>{cuota.fechaDelPago}</td>
                            </tr>
                        ))}
                        <tr className="cal-pie">
                            <td><strong>Total Cuotas</strong></td>
                            <td><strong>{formatoMonto(totalCuotas)}</strong></td>
                            <td><strong>Total Pago Cuotas</strong></td>
                            <td><strong>{formatoMonto(totalPagoCuotas)}</strong></td>
                            <td><strong>Saldo a Pagar</strong></td>
                            <td><strong>{formatoMonto(saldoAPagar)}</strong></td>
                        </tr>
                    </tbody>
                </table>
            )}
        </Fragment>
    );
};

export default CalendarioDeCuotas;
